// `extension-automation-criteria` — the automation configuration screen, at Full width.
//
// ⚠️ IT BORROWS THE CRITERIA BUILDER'S SHELL CLASSES AND IS NOT THAT SCREEN. The root div is
// `class="chrome-extension-search-page extension-automation-criteria"`, so the builder's page
// rules — the prediction box pinned top right, the two-column body — apply here, and the second
// class narrows them. Rendering this under its own class alone loses the layout; rendering it
// inside the builder's component would give it the builder's sections.
//
// ⚠️ AND THE PREDICTION IS A BARE NUMBER, NOT THE BUILDER'S BAR. `chrome-extension-search-page-prediction`
// holds a spinner until the first answer and then `{{ctrl.prediction.results}}` — no top-matches
// comparison, no bar, because what it counts is JOBS the automation would act on rather than
// candidates a search would find.
import type { ReactElement, ReactNode } from 'react'

export interface AutomationCriteriaPageProps {
  /** `ctrl.prediction` — undefined while the request is in flight, which is the spinner. */
  prediction?: number
  /**
   * `saveAutoMatchingConfig()`.
   *
   * ⚠️ NOT WIRED, AND THIS IS THE ONE BUTTON ON THIS BRANCH WHERE THAT MATTERS MOST. Saving here
   * decides which candidates an automated process puts in front of recruiters and who it emails,
   * on a tenant, from a build that reaches no user. The button renders and validates its own
   * enabled state; the call is a handler away (see `saveAutoMatchingConfig` in `@woo-ext/api`).
   */
  onSave?: () => void
  children: ReactNode
}

export function AutomationCriteriaPage({ prediction, onSave, children }: AutomationCriteriaPageProps): ReactElement {
  return (
    <div className="chrome-extension-search-page extension-automation-criteria">
      <div className="chrome-extension-search-page-prediction">
        {prediction === undefined ? (
          <div>
            <i className="fa fa-spinner fa-spin" />
          </div>
        ) : (
          <div>{prediction}</div>
        )}
      </div>
      <div className="criteria-container">{children}</div>
      <div className="extension-automation-criteria-footer">
        <div className="save-automation-criteria-button">
          {/* `click-and-disable` — a directive that disables the button for the life of the
              promise its handler returns. With no handler it never disables, which is the
              state the reference capture holds. */}
          <button
            type="button"
            onClick={() => {
              onSave?.()
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  )
}
